import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./header";
import Footer from "./footer";
import CartSheet from "@/web/components/products/cart-sheet";

export default function RootLayout() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!window.location.hash) window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior });
  }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CartSheet />
    </div>
  );
}
